'use client';

import { useEffect, useRef } from 'react';
import { useLandingAccount, landingAccountType } from './landingAccount';
import { sendLandingEvent } from './analytics';

export function usePremiumOfferImpression({ ctaLocation, billingInterval, locale }) {
  const target = useRef(null);
  const seen = useRef(new Set());
  const account = useLandingAccount();
  const accountType = landingAccountType(account);
  const enabled = accountType !== 'registered' || account?.isPremium === false;
  useEffect(() => {
    if (!enabled || !target.current || !window.IntersectionObserver) return undefined;
    const key = `${ctaLocation}:${billingInterval}:${accountType}`;
    if (seen.current.has(key)) return undefined;
    const observer = new IntersectionObserver(entries => {
      if (document.visibilityState === 'hidden' || !entries.some(item => item.isIntersecting && item.intersectionRatio >= 0.4)) return;
      if (sendLandingEvent('premium_offer_view', {
        cta_location: ctaLocation, offer_variant: `landing_${ctaLocation}`,
        billing_interval: billingInterval, account_type: accountType,
        landing_locale: locale, landing_path: window.location.pathname,
      })) {
        seen.current.add(key);
        observer.disconnect();
      }
    }, { threshold: 0.4 });
    observer.observe(target.current);
    return () => observer.disconnect();
  }, [enabled, ctaLocation, billingInterval, accountType, locale]);
  return target;
}
